import { Strings } from '@app/constants';
import { IWorkExperienceInfoSchema } from '../types';
import { InternalSubCard } from '@app/components/card';

interface EducationInfoProps {
  userData: IWorkExperienceInfoSchema;
}

const WorkExperienceInfo = ({ userData }: EducationInfoProps) => {
  const workExperienceDetails = userData?.workExperience ?? [
    {
      companyName: '',
      designationJobTitle: '',
      fromDate: '',
      toDate: '',
      jobDescription: '',
    },
  ];
  const subCards = workExperienceDetails.map((workExperience, index) => ({
    fields: [
      Strings.workExperience.companyName,
      Strings.workExperience.designationJobTitle,
      Strings.workExperience.fromDate,
      Strings.workExperience.toDate,
      Strings.workExperience.jobDescription,
    ],
    data: [
      workExperience.companyName || 'NA',
      workExperience.designationJobTitle || 'NA',
      workExperience.fromDate || 'NA',
      workExperience.toDate || 'NA',
      workExperience.jobDescription || 'NA',
    ],
  }));
  return (
    <>
      <InternalSubCard
        title={Strings.workExperience.workExperience}
        height={'270px'}
        subCards={subCards}
        iconImg="ic_workExperience"
      />
    </>
  );
};

export { WorkExperienceInfo };
